<div class="container">
  <!--<button mat-button (click)="onBack.emit(true)" class="back">
    <mat-icon>arrow_back</mat-icon>
  </button>-->
  <div *ngIf="inProgress" class="no-recording">{{ 'This maintenance is in progress...' | translate }}</div>
  <div *ngIf="!inProgress && !videoUrl" class="no-recording">{{ 'This maintenance is not recorded' | translate }}</div>
  <video *ngIf="videoUrl" width="100%" height="100%" controls autoplay>
    <source [src]="videoUrl" type="video/mp4">
    Your browser does not support the video tag.
  </video>
</div>
